import styled from 'styled-components'

export const Container = styled(({ height, ...props }) => <div {...props} />)`
  max-height: ${({ height }) => height};
  overflow-y: auto;
  width: 100%;
`
